import { VIEWING_SET_DOC_SEARCH_FOR_COMPARE_SUCCESS } from './constants';

export function setDocSearchForCompare(docSearchForCompare, docSearchLocationForCompare = null) {
  return {
    type: VIEWING_SET_DOC_SEARCH_FOR_COMPARE_SUCCESS,
    docSearchForCompare,
    docSearchLocationForCompare,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case VIEWING_SET_DOC_SEARCH_FOR_COMPARE_SUCCESS:
      return {
        ...state,
        docSearchForCompare: action.docSearchForCompare,
        docSearchLocationForCompare: action.docSearchLocationForCompare,
      };
    default:
      return state;
  }
}
